module.exports = __webpack_public_path__ + "img/2-low.223dd9d5.jpg";